/**
 * ui/interaction-ui.js
 * Quản lý tương tác nhân vật: Hành động (Actions), Biểu cảm (Expressions), Phản ứng mẫu (Reactions), Lời thoại TTS.
 */

import { AVATAR_PRESETS } from '../../avatars/avatar-presets.js';
import { escapeHtml } from '../../core/html.js';

export function initInteractionUI(state, globalAudioManager) {
  function syncExpressionButtonsUI(expr) {
    document.querySelectorAll('.btn-expression').forEach((b) => {
      b.classList.toggle('active', b.dataset.expression === expr);
    });
  }

  function syncActionButtonsUI(act) {
    document.querySelectorAll('.btn-action').forEach((b) => {
      b.classList.toggle('active', b.dataset.action === act);
    });
  }

  document.querySelectorAll('.btn-action').forEach((btn) => {
    btn.addEventListener('click', () => {
      syncActionButtonsUI(btn.dataset.action);
      state.currentAction = btn.dataset.action;
      if (state.mainAvatar) {
        state.mainAvatar.playAction(state.currentAction);
        syncExpressionButtonsUI(state.mainAvatar.currentExpression || 'happy');
      }
    });
  });

  document.querySelectorAll('.btn-expression').forEach((btn) => {
    btn.addEventListener('click', () => {
      syncExpressionButtonsUI(btn.dataset.expression);
      const expr = btn.dataset.expression;
      if (state.mainAvatar) {
        state.mainAvatar.setExpression(expr);
      }
    });
  });

  function updatePresetReactionsUI(presetKey) {
    let preset = null;
    if (typeof presetKey === 'object' && presetKey !== null) {
      preset = presetKey;
    } else {
      preset = AVATAR_PRESETS[presetKey] || AVATAR_PRESETS.TEACHER;
    }
    const container = document.getElementById('preset-reactions');
    if (!container) return;
    container.innerHTML = '';

    const commonReactions = [
      { action: 'thank_you', text: 'Cảm ơn bạn rất nhiều! Rất vui được đồng hành cùng bạn.' },
      { action: 'apologize', text: 'Ôi, thành thật xin lỗi bạn! Lần sau tôi sẽ cẩn thận hơn.' },
      { action: 'present', text: 'Kính thưa quý vị, sau đây là kết quả của mô hình thí nghiệm.' },
      { action: 'bow', text: 'Kính chào quý thầy cô và các bạn học sinh!' },
      { action: 'crawl', text: 'Bò sát mặt đất để luồn qua chướng ngại vật nào!' },
      { action: 'sit_ground', text: 'Mệt rồi, ngồi bệt xuống đất nghỉ ngơi một lát nào!' },
      { action: 'stand_up', text: 'Hít thở sâu, đứng dậy tiếp tục khám phá nào!' },
      { action: 'run', text: 'Nhanh lên nào, sắp đến giờ bắt đầu thí nghiệm rồi!' },
      { action: 'jump', text: 'Bật nhảy thật cao nào! Trọng lực đang kéo chúng ta xuống.' },
      { action: 'hop_one_leg', text: 'Nhảy lò cò một chân để kiểm tra thăng bằng trọng tâm!' },
      { action: 'stumble', text: 'Ôi chao! Sàn trơn quá, suýt chút nữa là mất thăng bằng rồi!' },
      { action: 'fall_backward', text: 'Ái da! Trượt chân ngã ngửa ra sau rồi, đau quá!' },
      { action: 'fall_forward', text: 'Úi trời! Bị vấp ngã sấp mặt rồi, may mà có tay đỡ!' },
      { action: 'roll_ground', text: 'Lăn tròn một vòng trên sàn xem lực ma sát tác động thế nào!' }
    ];

    const presetReactions = preset.defaultReactions || preset.reactions || [];
    const allReactions = [...presetReactions, ...commonReactions];

    allReactions.forEach((item) => {
      const div = document.createElement('div');
      div.className = 'reaction-item';
      div.innerHTML = `<strong>[${escapeHtml(item.action.toUpperCase())}]</strong> ${escapeHtml(item.text)}`;
      div.addEventListener('click', () => {
        if (state.mainAvatar) {
          syncActionButtonsUI(item.action);
          state.mainAvatar.playAction(item.action);
          syncExpressionButtonsUI(state.mainAvatar.currentExpression || 'happy');
          state.mainAvatar.speak(item.text);
        }
        const ttsToggle = document.getElementById('toggle-tts');
        if (ttsToggle && ttsToggle.checked && globalAudioManager) {
          globalAudioManager.playCue({
            text: item.text,
            characterId: state.currentPresetKey
          });
        }
      });
      container.appendChild(div);
    });
  }

  const btnSpeakCustom = document.getElementById('btn-speak-custom');
  if (btnSpeakCustom) {
    btnSpeakCustom.addEventListener('click', () => {
      const speechInput = document.getElementById('custom-speech');
      const text = speechInput ? speechInput.value.trim() : '';
      if (!text || !state.mainAvatar) return;
      state.mainAvatar.playAction('explain');
      state.mainAvatar.speak(text);
      const ttsToggle = document.getElementById('toggle-tts');
      if (ttsToggle && ttsToggle.checked && globalAudioManager) {
        globalAudioManager.playCue({
          text,
          characterId: state.currentPresetKey
        });
      }
    });
  }

  return {
    syncExpressionButtonsUI,
    syncActionButtonsUI,
    updatePresetReactionsUI
  };
}
